import { classNames, tv } from "@opensea/ui-kit"

export const mediaColumnClassNames = tv({
  base: classNames(
    "relative 3xl:col-span-6 lg:sticky lg:col-span-5",
    "items-end justify-start md:items-center 2xl:items-end",
    "border-border-1 border-b bg-bg-primary lg:border-r lg:border-b-0",
    "lg:h-[calc(100vh-theme(spacing.page-footer)-theme(spacing.lg-top-nav))]",
    "overflow-auto",
  ),
  variants: {
    variant: {
      modal: classNames(
        "lg:h-[calc(100vh-72px-32px-2px)] 2xl:h-[calc(100vh-72px-48px-2px)]",
        "2xl:items-center",
        "lg:top-[72px]",
      ),
      page: classNames(
        "lg:top-lg-top-nav lg:bottom-page-footer",
        "lg:h-[calc(100vh-theme(spacing.page-footer)-theme(spacing.lg-top-nav)-1px)]",
      ),
    },
  },
})
